import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { debounce } from "lodash-es";
import { action, runInAction } from "mobx";
import { observer } from "mobx-react";
import { useState } from "react";
import { ChromePicker } from "react-color";
import { useTranslation } from "react-i18next";
import isDefined from "../../Core/isDefined";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { RawButton } from "../../Styled/Button";
import { TextSpan } from "../../Styled/Text";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const debounceSetColorDimensionValue = debounce(action((dim, value) => {
  // Only update value if it has changed
  if (dim.value !== value) {
    dim.setDimensionValue(CommonStrata.user, value);
  }
}), 100);
export const SelectableDimensionColor = observer(_ref => {
  var _dim$value;
  let {
    dim
  } = _ref;
  const [open, setIsOpen] = useState(false);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("div", {
    children: [dim.value ? /*#__PURE__*/_jsx(_StyledDiv, {
      onClick: () => setIsOpen(true),
      children: /*#__PURE__*/_jsx(_StyledDiv2, {
        $_css: (_dim$value = dim.value) !== null && _dim$value !== void 0 ? _dim$value : "#aaa"
      })
    }) : null, !dim.value ? /*#__PURE__*/_jsxs(_Fragment, {
      children: ["\xA0", /*#__PURE__*/_jsx(RawButton, {
        onClick: () => runInAction(() => dim.setDimensionValue(CommonStrata.user, "#000000")),
        activeStyles: true,
        fullHeight: true,
        children: /*#__PURE__*/_jsx(_StyledTextSpan, {
          textLight: true,
          small: true,
          light: true,
          children: t("selectableDimensions.colorAdd")
        })
      })]
    }) : null, dim.value && dim.allowUndefined ? /*#__PURE__*/_jsxs(_Fragment, {
      children: ["\xA0", /*#__PURE__*/_jsx(RawButton, {
        onClick: () => runInAction(() => dim.setDimensionValue(CommonStrata.user, undefined)),
        activeStyles: true,
        fullHeight: true,
        children: /*#__PURE__*/_jsx(_StyledTextSpan2, {
          textLight: true,
          small: true,
          light: true,
          children: t("selectableDimensions.colorRemove")
        })
      })]
    }) : null, open ? /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(_StyledDiv4, {
        onClick: () => setIsOpen(false)
      }), /*#__PURE__*/_jsx(_StyledChromePicker, {
        color: dim.value,
        onChangeComplete: evt => {
          const colorString = isDefined(evt.rgb.a) ? "rgba(".concat(evt.rgb.r, ",").concat(evt.rgb.g, ",").concat(evt.rgb.b, ",").concat(evt.rgb.a, ")") : "rgb(".concat(evt.rgb.r, ",").concat(evt.rgb.g, ",").concat(evt.rgb.b, ")");
          debounceSetColorDimensionValue(dim, colorString);
        }
      })]
    }) : null]
  });
});
var _StyledDiv = _styled("div")({
  padding: "5px",
  background: "#fff",
  borderRadius: "1px",
  boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
  display: "inline-block",
  cursor: "pointer"
});
var _StyledDiv2 = _styled2("div")(p => ({
  width: "36px",
  height: "14px",
  borderRadius: "2px",
  background: p.$_css
}));
var _StyledTextSpan = _styled3(TextSpan)({
  margin: 0
});
var _StyledTextSpan2 = _styled4(TextSpan)({
  margin: 0
});
var _StyledDiv3 = _styled5("div")({
  position: "absolute",
  zIndex: 2
});
var _StyledDiv4 = _styled6("div")({
  position: "fixed",
  top: "0px",
  right: "0px",
  bottom: "0px",
  left: "0px",
  width: "340px"
});
var _StyledChromePicker = _styled7(ChromePicker).withConfig({
  displayName: "Color___StyledChromePicker",
  componentId: "sc-1tgmhgo-0"
})({
  transform: "translate(50px, -50%);"
});